import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ColorSelectionModalComponent } from './color-selection-modal/color-selection-modal.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-profile-avatar',
  templateUrl: './profile-avatar.component.html',
  styleUrls: ['./profile-avatar.component.scss'],
  imports: [CommonModule, MatIconModule],
})
export class ProfileAvatarComponent implements OnInit, OnChanges {
  @Input() image: string = '';
  @Input() name: string;
  @Input() color: string;
  @Input() size: number;
  @Input() showPaletteButton: boolean = false;
  @Input() showImageButton: boolean = false;
  @Input() showIsFavourite: boolean = false;
  @Input() canEdit: boolean = false;
  @Input() defaultIcon: string = '';
  @Input() shouldAnimate = false;
  @ViewChild('fileInput') fileInput: ElementRef;
  @Output() selectedColor = new EventEmitter<string>();
  @Output() selectedImage = new EventEmitter<File>();

  previousImage: string;
  previousName: string;
  previousColor: string;
  animateAvatarChange = false;

  colors = [
    '#F2A9D2',
    '#E376B4',
    '#C381E0',
    '#A56FBE',
    '#908DDE',
    '#89A3DE',
    '#608BED',
    '#60ACED',
    '#85CEE5',
    '#7AE3AA',
    '#97E58A',
    '#96C46F',
    '#6C9846',
    '#D5EA36',
    '#F7E729',
    '#FAD853',
    '#FA9A53',
    '#B97A4C',
    '#A58250',
    '#A53434',
  ];

  constructor(private dialog: MatDialog) {}

  ngOnInit() {
    if (!this.color) {
      this.color = '#CCC';
    }
  }

  private getRandomColor(): string {
    const randomIndex = Math.floor(Math.random() * this.colors.length);
    return this.colors[randomIndex];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.name &&
      changes.name.previousValue === '' &&
      changes.name.currentValue !== ''
    ) {
      this.color = this.getRandomColor();
      this.selectedColor.emit(this.color);
    }
    if (!this.shouldAnimate) return;
    if (
      (changes.image && changes.image?.previousValue) ||
      (changes.name && changes.name?.previousValue) ||
      (changes.color && changes.color?.previousValue)
    ) {
      this.previousImage = changes.image?.previousValue;
      this.previousName = changes.name?.previousValue;
      this.previousColor = changes.color?.previousValue;
      this.animateAvatarChange = true;
      setTimeout(() => {
        this.previousImage = this.image;
        this.previousName = this.name;
        this.previousColor = this.color;
        this.animateAvatarChange = false;
      }, 1500);
    } else {
      this.previousImage = this.image;
      this.previousName = this.name;
      this.previousColor = this.color;
    }
  }

  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.uploadFile(file);
    }
  }

  uploadFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.image = e.target.result;
      this.selectedImage.emit(file);
    };
    reader.readAsDataURL(file);
  }

  removePhoto(): void {
    this.image = null;
    this.fileInput.nativeElement.value = '';
    this.selectedImage.emit(null);
  }

  getInitials(name: string) {
    if (name) {
      const initials = name
        .split(' ')
        .map(n => n[0])
        .join('');
      if (initials.length > 2) {
        const _ = initials.split('');
        return `${_[0]}${_[_.length - 1]}`;
      }
      return initials;
    }
  }

  openColorSelectionModal() {
    this.dialog
      .open(ColorSelectionModalComponent, {
        width: '300px',
        autoFocus: false,
        data: { selectedColor: this.color },
      })
      .afterClosed()
      .subscribe(color => {
        if (color) {
          this.color = color;
          this.selectedColor.emit(color);
        }
      });
  }
}
